import common from '../modules/common.en'
import menu from '../modules/menu.en'
import field from '../modules/field.en'
import status from '../modules/status.en'
import type from '../modules/type.en'
import msg from '../modules/msg.en'
import placeholder from '../modules/placeholder.en'
import log from '../modules/log.en'
import dict from '../modules/dict.en'
import notification from '../modules/notification.en'
import dashboard from '../modules/dashboard.en'
import airline from '../modules/airline.en'
import role from '../modules/role.en'
import time from '../modules/time.en'
import feature from '../modules/feature.en'

export default {
  common,
  menu,
  field,
  status,
  type,
  unit: type.unit,
  msg,
  placeholder,
  log,
  dict,
  notification,
  dashboard,
  airline,
  role,
  time,
  feature,
}
